import React from "react";
import "./BridalMakeUpPackageCustomer.css";
const BridalMakeUpPackageCustomer = () => {
  return (
    <div className="BridalMakeUpCustomerContainer">
      <h5>Client Testimonials: Real Brides, Real Stories</h5>
      <p>
        Our Bridal Makeup Packages in Bangalore have delighted many brides. Here
        are a few testimonials:
      </p>
      <div className="BridalMakeUpCustomerContent">
        <p>
          <span className="quote">"</span> SCENT made my wedding day
          unforgettable. Their Bridal Makeup Packages in Bangalore are amazing.
          The team was professional and attentive, and I felt like a queen on my
          big day. <span className="quote">"</span> - <span>Priya s. </span>
        </p>
        <p>
          <span className="quote">"</span> I was so nervous about my wedding
          look, but SCENT's Bridal Makeup Packages in Bangalore exceeded my
          expectations. The trial session was great, and the final look was
          exactly what I wanted. <span className="quote">"</span> -{" "}
          <span>Anjali M. </span>
        </p>
        <p>
          <span className="quote">"</span> Choosing SCENT for my Bridal Makeup
          Packages in Bangalore was the best decision. The team was fantastic,
          and the on-site services made everything so convenient. I highly
          recommend them! <span className="quote">"</span> -{" "}
          <span>Meera R. </span>
        </p>
      </div>
    </div>
  );
};

export default BridalMakeUpPackageCustomer;
